import { render, staticRenderFns } from "./PersonSelect.vue?vue&type=template&id=1da561ad&scoped=true"
import script from "./PersonSelect.vue?vue&type=script&lang=js"
export * from "./PersonSelect.vue?vue&type=script&lang=js"
import style0 from "./PersonSelect.vue?vue&type=style&index=0&id=1da561ad&prod&scoped=true&lang=less"
import style1 from "./PersonSelect.vue?vue&type=style&index=1&id=1da561ad&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da561ad",
  null
  
)

export default component.exports